module.exports = __webpack_public_path__ + "img/gzh.852c7834.jpg";